// EDEN · the calm offline state. The shell loads from the service-worker cache; the data
// area says a friendly "You're offline" — never an alarm (Design Brief tone rail). No data
// is cached, so there is nothing stale to show — just a quiet wait for the signal to return.

import { ApiError } from "./api";
import { t } from "./i18n";

/**
 * True when a thrown error is a lost-connection failure (offline), not a real server reply.
 * `fetch()` rejects with a `TypeError` when the network is down; an `ApiError` means the
 * server answered (4xx/5xx) and should surface as itself, not as "offline".
 */
export function isNetworkError(err: unknown): boolean {
  if (err instanceof ApiError) return false;
  return err instanceof TypeError || !navigator.onLine;
}

/** True while the offline panel (not a working page) is what's on screen. */
export function isOfflineShowing(): boolean {
  return !!document.querySelector("[data-offline-panel]");
}

/** Paint a calm, reassuring offline panel into the app root. */
export function renderOffline(app: HTMLElement): void {
  app.innerHTML = `
    <div class="topbar" data-offline-panel><a data-link href="/" class="muted">${t("common.back_home")}</a></div>
    <h1>${t("offline.title")}</h1>
    <p class="empty">${t("offline.body")}</p>
    <button class="btn" id="retry" type="button">${t("offline.retry")}</button>`;
  app
    .querySelector<HTMLButtonElement>("#retry")
    ?.addEventListener("click", () => window.dispatchEvent(new Event("eden:rerender")));
}
